<template>
  <div id="app" @mousedown="mousedown()" @mouseup="mouseup()">
    <router-view />
  </div>
</template>

<script>
import param from "../static/config/param";

export default {
  methods: {
    browserUpdate() {
      //main大小
      this.mainUpdate(window.innerWidth, window.innerHeight);
      //浏览器大小
      let browser = this.$store.state.browser;
      if (
        (browser.width > window.innerWidth && !this.$store.state.collapse) ||
        (browser.width < window.innerWidth && this.$store.state.collapse)
      ) {
        //菜单是否展开
        let collapse = window.innerWidth < 1150;
        this.$store.commit("SET_COLLAPSE", collapse);
      }
      browser.width = window.innerWidth;
      browser.height = window.innerHeight > 568 ? window.innerHeight : 568;
      this.$store.commit("SET_BROWSER", browser);
    },
    mainUpdate(innerWidth, innerHeight) {
      let content = this.$store.state.content;
      content.height = innerHeight - 70;
      content.width = innerWidth - (this.$store.state.collapse ? 65 : 250);
      this.$store.commit("SET_CONTENT", content);
      //列表高度
      let tableHeight = content.height > 500 ? content.height - 220 : 280;
      this.$store.commit("SET_TABLEHEIGHT", tableHeight);
    },
    //按住鼠标
    mousedown() {
      this.$store.commit("SET_PRESSING", true);
    },
    //松开鼠标
    mouseup() {
      this.$store.commit("SET_PRESSING", false);
    }
  },
  computed: {
    getMQTT() {
      return this.$store.state.mqttData;
    },
  },
  watch: {
    getMQTT: {
      handler(newVal) {
        if (newVal.hasOwnProperty("deviceId")) {
          if (newVal.eventType === "1") {
            this.$message.success(
              `${newVal.deviceName} - ${newVal.eventName.name[this.$store.state.language]
              } - ${this.method.timeFormat(newVal.eventTime)}`
            );
          } else {
            this.$message.error(
              `${newVal.deviceName} - ${newVal.eventName.name[this.$store.state.language]
              } - ${this.method.timeFormat(newVal.eventTime)}`
            );
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    //浏览器大小调整
    window.onresize = () => {
      return (() => {
        this.browserUpdate();
      })();
    };
    //防止页面后退
    window.addEventListener(
      "popstate",
      function () {
        this.$router.replace("login");
      }.bind(this)
    );
  },
  created() {

    //加载高德sdk
    this.method.addScript(
      "https://webapi.amap.com/maps?v=1.4.15&key=" +
      param.gaode.key +
      "&plugin=AMap.Geocoder"
    );
    //加载谷歌sdk
    this.method.addScript(
      "https://maps.googleapis.com/maps/api/js?key=" +
      param.google.key +
      "&libraries=places"
    );
    //根据浏览器语言，保存用户语言及日期格式
    this.method.browserLanguage();
    //获取浏览器大小
    this.browserUpdate();
  }
};
</script>

<style>
@import "../static/css/main.css";
@import "../static/css/iconfont.css";
@import "../static/css/iconfont1.css";
@import "../static/font2/iconfont.css";
</style>



// WEBPACK FOOTER //
// src/App.vue